import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { HttpContext } from "src/contexts/HttpContextProvider";
import { useLocalizedDate } from "src/CustomHooks";

function Subscription() {
	const { t } = useTranslation();
	const [subscription, setSubscription] = useState<ISubscription>();
	const http = useContext(HttpContext);
	const localizedDate = useLocalizedDate();


	useEffect(() => {
		http.getHttp<ISubscription>("subscriptions/current").then(res => {
			setSubscription(res.data);
		});
	}, []);

	const cancelSubscription = () => {
		http.postHttp("subscriptions/cancel");
	};


	return <Card>
		<CardContent>
			<Typography variant="h5" gutterBottom>
				{t("Subscription")}
			</Typography>
			<Typography variant="body1" gutterBottom>
				{t("CurrentPlan")} <strong>{subscription?.plan?.name}</strong>
			</Typography>
			<Typography variant="body1" gutterBottom>
				{t("BillingEnd")}
				<strong>{
					subscription?.endAt
						? localizedDate(subscription.endAt)
						: "- "}
				</strong>
			</Typography>
			<Box display="flex" justifyContent="flex-end">
				<Button variant="contained" color="error"
					disabled={subscription?.paddleSubscriptionId === null || http.loading}
					sx={{ mt: 2 }} onClick={cancelSubscription}>
					{t("CancelSubscription")}
				</Button>
			</Box>
		</CardContent>
	</Card>;
}

export default Subscription;
